import { useContext } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import video_details from "../../assets/images/video-details.jpg";
import { NavLink } from "react-router-dom";
import BackButton from "../../components/common/BackButton";

const TripVideoDetails = () => {
  const { t } = useContext(LocaleContext);
  return (
    <section className="trip-video-details">
      <div className="default-heading">{t("tripVideos")}</div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center">
          {t("videoDetails")}
          <BackButton />
        </div>
        <div className="my-card-body">
          <div className="trip-video-details-container">
            <img
              src={video_details}
              alt="Video Details"
              className="video-thumbnail"
            />
          </div>
          <strong className="mt-3">{t("videoStatistics")}</strong>
          <section className="trip-video-boxes">
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="trip-video-box my-bg-primary">
                  <b>{t("creationDate")}</b>
                  <span>10-02-2026</span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="trip-video-box my-bg-dark-blue">
                  <b>{t("associatedTrips")}</b>
                  <span>36 {t("trips")}</span>
                  <span>
                    {t("completed")} 0 : {t("cancelled")} : 0
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="trip-video-box my-bg-primary">
                  <b>{t("containsALink")}</b>
                  <span>{t("yes")}</span>
                </div>
              </div>
            </div>
          </section>
          <section className="section-video-information mt-3">
            <div className="my-card">
              <strong>{t("videoInformation")}</strong>
              <div className="video-information-items mt-3">
                <div className="video-information-item">
                  <span>{t("address")} :</span>
                  <span>{t("trips")}</span>
                </div>
                <div className="video-information-item">
                  <span>{t("subTitle")} :</span>
                  <span>الجبيل</span>
                </div>
                <div className="video-information-item">
                  <span>{t("Link")} :</span>
                  <a href="#">https://example.com</a>
                </div>
                <div className="video-information-item">
                  <span>{t("creationDate")} :</span>
                  <span>٦ ديسمبر ٢٠٢٥ في ١١:٢٧ ص</span>
                </div>
              </div>
            </div>
            <NavLink to="/trip-videos" className="d-flex justify-content-end text-decoration-none"> 
              <button className="btn-secondary mt-3">{t("back")}</button>
            </NavLink>
          </section>
        </div>
      </div>
    </section>
  );
};

export default TripVideoDetails;
